module.exports = require("web3-eth-contract");